import {
  signIn,
  signOut,
  getServerSession as getServerSessionAuth,
} from '@checkatrade/auth/cjs';
import { track } from 'lib/sdks/analytics';
import { logger } from 'lib/utils/logger';
import { type NextApiRequest } from 'next';

export const ALLOWED_AUTH_REDIRECTS = [
  '/debug?token=1234',
  '/account',
  '/consumer/messages',
  '/consumer/jobs', // Add more trades
  '/consumer/saved-trades',
  '/account/register',
  '/message/contact-information',
  '/give-feedback',
] as const;

/**
 * Allowed callback urls for login. These should be whitelisted in auth provider before being added here.
 */
type AllowedCallbacks = (typeof ALLOWED_AUTH_REDIRECTS)[number] | (string & {});

export const login = (callbackUrl: AllowedCallbacks = '/account') => {
  const validatedCallbackUrl = ALLOWED_AUTH_REDIRECTS.includes(callbackUrl)
    ? callbackUrl
    : '/account';

  track('global.login_click', { callback: callbackUrl });

  void signIn(validatedCallbackUrl);
};

export const logout = () => {
  void signOut();
};

export const getServerSession = async (req: {
  cookies: Partial<{ [p: string]: string }>;
}) => {
  try {
    const session = await getServerSessionAuth(req as NextApiRequest);
    return session ? session : ({ activeSession: false } as const);
  } catch (e) {
    logger.error(e, 'getServerSession error');
    return { activeSession: false } as const;
  }
};
